<template>
  <div class="pattern-password">
    <div class="pattern-container">
      <div
        v-for="emoji in availableEmojis"
        :key="emoji"
        class="pattern-item"
        :class="{ selected: isSelected(emoji) }"
        @click="toggleEmoji(emoji)"
      >
        {{ emoji }}
      </div>
    </div>
    <div class="selected-patterns">
      <p>Selected graphics:</p>
      <div class="selected-list">
        <div
          v-for="(emoji, index) in modelValue"
          :key="index"
          class="selected-item"
        >
          {{ emoji }}
          <button class="remove-btn" @click.stop="removeEmoji(index)">×</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  emojis: {
    type: Array,
    default: null,
  },
});

const emit = defineEmits(["update:modelValue"]);

const availableEmojis = computed(() => {
  return props.emojis && props.emojis.length > 0
    ? props.emojis
    : [
        "🏀",
        "🚗",
        "🌈",
        "🌺",
        "🐱",
        "🐶",
        "🦊",
        "🦁",
        "🐼",
        "🐻",
        "🌍",
        "🍎",
        "🍉",
        "🍦",
        "⚽",
        "🎮",
        "🎸",
        "🚀",
        "🌙",
        "☀️",
        "🏠",
        "🎁",
        "🎈",
        "🔑",
      ];
});

function isSelected(emoji) {
  return (props.modelValue || []).includes(emoji);
}

function toggleEmoji(emoji) {
  const value = props.modelValue || [];
  if (isSelected(emoji)) {
    removeEmoji(value.indexOf(emoji));
  } else if (value.length < 2) {
    emit("update:modelValue", [...value, emoji]);
  } else if (value.length === 2) {
    // 移除第一個，加入新選的
    emit("update:modelValue", [value[1], emoji]);
  }
}

function removeEmoji(index) {
  const value = props.modelValue || [];
  const newValue = [...value];
  newValue.splice(index, 1);
  emit("update:modelValue", newValue);
}
</script>

<style scoped>
.pattern-password {
  margin: 20px 0;
}

.pattern-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}

.pattern-item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  background-color: #f8f8f8;
  border-radius: 50%;
  transition: transform 0.2s, background-color 0.2s;
}

.pattern-item:hover {
  transform: scale(1.1);
  background-color: #eeeeff;
}

.pattern-item.selected {
  background-color: #e6f7ff;
  border: 2px solid #1890ff;
}

.selected-patterns {
  margin-top: 20px;
}

.selected-patterns p {
  margin-bottom: 10px;
  font-weight: 500;
}

.selected-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.selected-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f0f8ff;
  border-radius: 20px;
  font-size: 20px;
}

.remove-btn {
  margin-left: 8px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ff6b6b;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 0;
}

.remove-btn:hover {
  background-color: #ff5252;
}
</style>
